import React from "react";
import { Container } from "reactstrap";
import PropTypes from "prop-types";

const HomeFooter = (props) => {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "") + " homeFooter"}>
      <Container fluid={props.fluid ? true : false}>
        <ul className="nav">
          <li className="nav-item">
            <a className="nav-link" href="https://rustlink.io/privacy">
              Privacy policy
            </a>
          </li>{" "}
          <li className="nav-item">
            <a className="nav-link" href="https://rustlink.io/tos">
              Terms of service
            </a>
          </li>{" "}
          <li className="nav-item">
            <a className="nav-link" href="https://rustlink.io/discord">
              Discord
            </a>
          </li>
        </ul>
        <div className="copyright">
          © {new Date().getFullYear()} {" "}
          RustLink.io
        </div>
      </Container>
    </footer>
  );
};

HomeFooter.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default HomeFooter;
